import React from "react";

function SingleRotaryTabletPress() {
  return (
    <>
      <style>{`
      .technical-spec-section {
        margin: 40px 0;
        overflow-x: auto;
      }
      .technical-spec-section h4 {
        font-family: 'Oxygen', sans-serif;
        font-weight: bold;
        font-size: 24px;
        color: #000;
        margin-bottom: 20px;
      }
      .table {
        width: 100%;
        border-collapse: collapse;
        background: white;
      }
      .table-bordered {
        border: 1px solid #ddd;
      }
      .table-bordered td {
        border: 1px solid #ddd;
        padding: 12px 15px;
        font-size: 14px;
      }
      .table tbody tr:nth-child(even) {
        background-color: #f2f2f2;
      }
      .table td:first-child {
        font-weight: 600;
        width: 40%;
      }
    `}</style>

      <main id="primary" className="site-main">
        <div className="space-for-header"></div>

        {/* Breadcrumb Section */}
        <section
          className="tj-page-header section-gap-x"
          data-bg-image="assets/images/bg/pheader-bg.webp"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="tj-page-header-content text-center">
                  <h1 className="tj-page-title">Single Rotary Tablet Press</h1>
                  <div className="tj-page-link">
                    <span><i className="fa-solid fa-home"></i></span>
                    <span><a href="/">Home</a></span>
                    <span><i className="fa-solid fa-arrow-right"></i></span>
                    <span><span>Single Rotary Tablet Press</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="page-header-overlay"
            data-bg-image="assets/images/shape/pheader-overlay.png"
          ></div>
        </section>

        {/* MAIN CONTENT */}
        <section className="tj-blog-section section-gap slidebar-stickiy-container">
          <div className="container">
            <div className="row row-gap-5">

              {/* LEFT CONTENT */}
              <div className="col-lg-8">
                <div className="post-details-wrapper">

                  {/* MAIN IMAGE */}
                  <div className="blog-images wow fadeInUp" data-wow-delay=".1s">
                    <img
                      src="assets/images/SD_PHRMA_ALL_MIX _JPGS/9.png"
                      alt="Single Rotary Tablet Press"
                      style={{ width: "100%", maxHeight: "500px", objectFit: "cover" }}
                    />
                  </div>

                  <h2 className="title title-anim">
                    Single Rotary Tablet Press
                  </h2>

                  <div className="blog-text">
                    <p className="wow fadeInUp" data-wow-delay=".3s">
                      The Single Rotary Tablet Press is ideal for small to medium scale
                      pharmaceutical and nutraceutical production. Its simple
                      single-sided compression mechanism ensures smooth operation,
                      excellent tablet uniformity, and reliable performance.
                    </p>

                    <p className="wow fadeInUp" data-wow-delay=".4s">
                      Designed with a robust structure, easy maintenance, stainless
                      steel contact parts, and operator-friendly controls, this machine
                      is suitable for continuous production with consistent tablet
                      hardness and weight accuracy.
                    </p>
                  </div>

                  {/* EXTRA IMAGES */}
                  <div className="images-wrap">
                    <div className="row">

                      <div className="col-sm-6">
                        <div className="image-box wow fadeInUp" data-wow-delay=".3s">
                          <img src="assets/images/SD_PHRMA_ALL_MIX _JPGS/10.png" alt="Image" />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="image-box wow fadeInUp" data-wow-delay=".5s">
                          <img src="assets/images/SD_PHRMA_ALL_MIX _JPGS/8.png" alt="Image" />
                        </div>
                      </div>

                    </div>
                  </div>

                  {/* TECHNICAL SPECIFICATIONS */}
                  <div className="technical-spec-section">
                    <h4>Technical Specification</h4>

                    <table className="table table-bordered">
                      <tbody>

                        <tr>
                          <td>Model</td>
                          <td>DPM-1 GMP</td>
                          <td>DPM-16 B</td>
                          <td>DPM-20 B</td>
                          <td>DPM-23 B</td>
                          <td>DPM-27 B</td>
                          <td>DPM-30 B</td>
                        </tr>

                        <tr>
                          <td>Number of Stations</td>
                          <td>1</td>
                          <td>16</td>
                          <td>20</td>
                          <td>23</td>
                          <td>27</td>
                          <td>30</td>
                        </tr>

                        <tr>
                          <td>Output (Tablets / Hour)</td>
                          <td>900–1800</td>
                          <td>14,400</td>
                          <td>18,000</td>
                          <td>20,700</td>
                          <td>25,200</td>
                          <td>28,000</td>
                        </tr>

                        <tr>
                          <td>Max Tablet Diameter</td>
                          <td>25 mm</td>
                          <td>25 mm</td>
                          <td>16 mm</td>
                          <td>16 mm</td>
                          <td>12 mm</td>
                          <td>12 mm</td>
                        </tr>

                        <tr>
                          <td>Max Depth of Fill</td>
                          <td>20 mm</td>
                          <td>20 mm</td>
                          <td>17 mm</td>
                          <td>17 mm</td>
                          <td>15 mm</td>
                          <td>15 mm</td>
                        </tr>

                        <tr>
                          <td>Main Compression Pressure</td>
                          <td>10 Tons</td>
                          <td>10 Tons</td>
                          <td>6.5 Tons</td>
                          <td>6.5 Tons</td>
                          <td>6 Tons</td>
                          <td>6 Tons</td>
                        </tr>

                        <tr>
                          <td>Turret Speed</td>
                          <td>20 RPM</td>
                          <td>20 RPM</td>
                          <td>20 RPM</td>
                          <td>20 RPM</td>
                          <td>20 RPM</td>
                          <td>20 RPM</td>
                        </tr>

                        <tr>
                          <td>Main Motor</td>
                          <td>3 HP</td>
                          <td>3 HP</td>
                          <td>2 HP</td>
                          <td>2 HP</td>
                          <td>2 HP</td>
                          <td>2 HP</td>
                        </tr>

                        <tr>
                          <td>Machine Dimensions (L × W × H)</td>
                          <td>850 × 600 × 1550 mm</td>
                          <td>900 × 700 × 1600 mm</td>
                          <td>900 × 700 × 1600 mm</td>
                          <td>900 × 700 × 1600 mm</td>
                          <td>900 × 700 × 1600 mm</td>
                          <td>900 × 700 × 1600 mm</td>
                        </tr>

                        <tr>
                          <td>Machine Weight</td>
                          <td>350 kg</td>
                          <td>650 kg</td>
                          <td>700 kg</td>
                          <td>750 kg</td>
                          <td>800 kg</td>
                          <td>850 kg</td>
                        </tr>

                      </tbody>
                    </table>
                  </div>

                </div>
              </div>

              {/* RIGHT SIDEBAR */}
              <div className="col-lg-4 sidebar-container">
                <div className="tj-main-sidebar">

                  <div className="tj-sidebar-widget service-categories">
                    <h4 className="widget-title">Related Products</h4>
                    <ul>
                      <li>
                        <a href="/double-side-rotary-tableting-machine">
                          Double Side Rotary Tableting Machine
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/mini-tablet-press">
                          Mini Tablet Press
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/r-d-tablet-press">
                          R&D Tablet Press
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/multi-layer-tablet-press">
                          Multi Layer Tablet Press
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/lab-tablet-press">
                          Lab Tablet Press
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                    </ul>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </section>

      </main>
    </>
  );
}

export default SingleRotaryTabletPress;
